var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNetworkSecurityManagementServiceIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 73,
    viewBox: "0 0 73 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.443848,
    y: 0.0564575,
    width: 72.5033,
    height: 72.5033,
    rx: 10.3576,
    fill: "#FCA100"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.6953 22.0667C44.5608 22.0667 50.9371 28.4429 50.9371 36.3084C50.9371 44.1739 44.5608 50.5501 36.6953 50.5501C28.8298 50.5501 22.4536 44.1739 22.4536 36.3084C22.4536 28.4429 28.8298 22.0667 36.6953 22.0667ZM25.128 34.8938C25.5055 35.3769 26.555 35.995 28.161 36.4994C28.7934 36.6979 29.4859 36.8725 30.229 37.0207C30.2242 36.7847 30.2218 36.5472 30.2218 36.3084C30.2218 32.0001 31.0058 28.1094 32.364 25.4876C28.4923 27.0388 25.6467 30.6078 25.128 34.8938ZM30.389 39.6886C28.31 39.3272 26.5273 38.7803 25.1763 38.0767C25.8048 42.2047 28.5993 45.6208 32.364 47.1291C31.3724 45.2149 30.6868 42.6243 30.389 39.6886ZM33.0429 40.0337C34.2043 40.1383 35.4277 40.1925 36.6953 40.1925C37.9426 40.1925 39.1714 40.1218 40.3532 39.9907C39.7692 44.6485 38.1545 47.9607 36.6953 47.9607C35.2407 47.9607 33.6314 44.6688 33.0429 40.0337ZM40.5617 37.35C39.3323 37.5092 38.0264 37.6031 36.6953 37.6031C35.3434 37.6031 34.0456 37.5361 32.8311 37.4092C32.818 37.0471 32.8112 36.6799 32.8112 36.3084C32.8112 29.8141 34.8745 24.6561 36.6953 24.6561C38.5162 24.6561 40.5794 29.8141 40.5794 36.3084C40.5794 36.6597 40.5734 37.0071 40.5617 37.35ZM43.0125 39.5799C42.7207 42.5604 42.0305 45.1913 41.0267 47.1291C44.8579 45.5941 47.6842 42.0835 48.2456 37.8574C46.873 38.5713 45.0652 39.1683 43.0125 39.5799ZM48.2551 34.8326C47.6459 35.5164 45.7242 36.3288 43.164 36.8963C43.1672 36.7013 43.1688 36.5053 43.1688 36.3084C43.1688 32.0001 42.3848 28.1094 41.0267 25.4876C44.88 27.0315 47.7168 30.5738 48.2551 34.8326Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetworkSecurityManagementServiceIcon);
export default __webpack_public_path__ + "static/media/NetworkSecurityManagementServiceIcon.90713a6e849ad5eee0c212df15db18d4.svg";
export { ForwardRef as ReactComponent };